import React, { useState } from "react";

const ApplicationProcedureYEE = () => {
  const [activeSection, setActiveSection] = useState(null);

  const handleToggle = (sectionId) => {
    setActiveSection(activeSection === sectionId ? null : sectionId);
  };

  const sections = [
    {
      id: 1,
      title: "Application Procedure",
      content: `Interested candidates are invited to submit their applications through our online portal. Applications should include a statement of purpose delineating the applicant's aspirations & motivations for undertaking the course, along with academic transcripts reflecting their educational background & achievements.`,
    },
    {
      id: 2,
      title: "Programme Cost",
      content: `The programme fee for the Emerging Entrepreneur Course is $350 for the entire 15-credit course. Please note that additional administrative fees may apply. Financial aid & scholarships may be available for eligible students. For detailed information on fees & payment options, kindly contact our admissions office.

      Embark on your entrepreneurial journey today & seize the opportunity to transform your innovative ideas into tangible realities. Apply now & join a vibrant community of aspiring entrepreneurs poised to shape the future of business & society.`,
    },
  ];

  return (
    <div
      className="md:scroll-mt-44 scroll-mt-16 my-10"
      id="application-procedure"
    >
      <div className="bg-gradient-to-r from-gray-600 to-blue-950 py-10">
        <div className="max-w-6xl mx-auto px-10 space-y-8">
          <h2 className="text-2xl font-extrabold text-center mb-6 text-white">
            Application Procedure & Programme Cost
          </h2>
          <div className="bg-sdbodywhiteywhitebodyywhitebody h-1 w-20 mx-auto rounded"></div>
          <div className="space-y-4">
            {sections.map((section) => (
              <div
                key={section.id}
                className="border border-gray-300 rounded-lg overflow-hidden shadow-lg"
              >
                <button
                  onClick={() => handleToggle(section.id)}
                  className="w-full text-left py-4 px-5 bg-blue-100 hover:bg-blue-200 focus:outline-none"
                >
                  <div className="flex justify-between items-center">
                    <span className="font-semibold text-lg text-gray-700">
                      {section.title}
                    </span>
                    <span className="text-gray-600">
                      {activeSection === section.id ? "▲" : "▼"}
                    </span>
                  </div>
                </button>
                {activeSection === section.id && (
                  <div className="px-5 py-4 bg-sdbodywhiteywhitebodyywhitebody">
                    <p className="text-gray-800 leading-relaxed whitespace-pre-line">
                      {section.content}
                    </p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ApplicationProcedureYEE;
